exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".GIS_Client .mapErrorMessage {\r\n    font-size: 16px;\r\n    color: red;\r\n}\r\n", ""]);

// exports
